import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {  FormBuilder, FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { indexOf, sortBy, uniqWith } from 'lodash';
import { forkJoin, combineLatest, Subscription } from 'rxjs';
import { BeachSite } from '../../models/BeachSite';
import { Council, Region, getBeachSitesInArea, isSubRegion } from '../../models/SiteGroups';
import { ListService } from '../../services/list.service';
import { SitesService } from '../../services/sites.service';
import { CheckboxListValidators } from '../../CustomValidators/CheckboxListValidators';
import { UserSubscriptionService } from '../../services/user-subscription.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserFeedbackDialogComponent } from 'src/app/shared/user-feedback-dialog/user-feedback-dialog.component';
import { DialogService } from 'src/app/shared/CustomDialog/DialogService';
import { DialogRef } from 'src/app/shared/CustomDialog/DialogRef';
import { LOOKUP_AREA_TYPES } from 'src/app/models/lookupAreaTypes';
import { RegionCouncilBeachSitesSelectionComponent } from 'src/app/water-monitoring/region-council-beach-sites-selection/region-council-beach-sites-selection.component';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
	selector: 'app-user-subscriptions',
	templateUrl: './user-subscriptions.component.html',
	styleUrls: ['./user-subscriptions.component.scss'],
	providers : [SitesService, ListService, UserSubscriptionService, MatSnackBar]	
})

export class UserSubscriptionsComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

	COMM_METHODS = ["sms", "email"];
	UPDATE_FREQUENCY = ["Year-round", "Select specific months"];
	public preSelectedBeachSite : string = "";
	private handle : Subscription;
	public allBeachSites : BeachSite[];
	public allRegions : Region[];
	public allCouncils : Council[];	
	private apiRequestsSub : Subscription;	
	private postSubscribeSub : Subscription;
	
	public updateFreqSelectedMonths : string[] = [];	
	public selecteUpdateFrequency = "";	
	
	public updateMonths : string[] = ['January', 'February', 'March',
						'April', 'May','June',
						'July', 'August','September',
						'October', 'November','December'];	

	private emailValidators = [Validators.email, Validators.required, Validators.minLength(8)];	
	
	popupDialogRef : DialogRef;
	suppressPopup : boolean = false;
	submittingForm : boolean = false;
	
	@ViewChild(RegionCouncilBeachSitesSelectionComponent) regionCouncilBeachSiteSelector : RegionCouncilBeachSitesSelectionComponent;

	userSubscriptionsForm = this.formBuilder.group({
		firstName : ["", { validators : [Validators.required, Validators.minLength(3), Validators.maxLength(15), Validators.pattern(/^[a-zA-Z]+[a-zA-Z(0-9_\-)*]*$/)]}],	
		lastName : ["", { validators : [Validators.minLength(3), Validators.maxLength(15)]}],	
		email : ["", { validators : this.emailValidators }],		
		updateFrequency : [""],
		selectedMonths : this.formBuilder.array([
			this.formBuilder.control(false), this.formBuilder.control(false), this.formBuilder.control(false),
			this.formBuilder.control(false), this.formBuilder.control(false), this.formBuilder.control(false),
			this.formBuilder.control(false), this.formBuilder.control(false), this.formBuilder.control(false),
			this.formBuilder.control(false), this.formBuilder.control(false), this.formBuilder.control(false)
		])
	});	
	

	constructor(private formBuilder : FormBuilder,
		private sitesService : SitesService,
		private listService : ListService,
		private userSubscribeService : UserSubscriptionService,
		private snackBar: MatSnackBar, 
		private activatedRoute : ActivatedRoute,
		private router : Router) 
	{
		
	}
	

	ngOnInit(): void {
		this. loadData();	

		this.updateFrequency?.valueChanges.subscribe( {
			next : (data) => {
				this.selecteUpdateFrequency = data ?? "";
				if(this.UPDATE_FREQUENCY[1] === data)
				{
					this.selectedMonths?.addValidators(CheckboxListValidators.atleastOneCheckboxChecked());	
					this.selectedMonths?.addValidators(Validators.required);						
				}
				else
				{
					this.selectedMonths?.clearValidators();
				}
			}
		});

		this.selectedMonths?.valueChanges.subscribe({
			next : (data) => {
				const selCount = this.selectedMonths?.controls?.filter((control : any) => (<FormControl>control)?.value)?.length;
				if(this.updateMonths.length === selCount)
				{
					this.updateFrequency?.patchValue(this.UPDATE_FREQUENCY[0]);
					this.selectedMonths?.controls?.forEach((control : any) => (<FormControl>control)?.patchValue(false));
				}
			},
			error : (ex) =>
			{

			},
			complete : () => {

		}});

		this.handle = this.activatedRoute.queryParams.subscribe({
			next : (params : any) => 
			{		
				// this is set from the Subscribe button on Site details page		
				this.preSelectedBeachSite = params.siteIdentifier ?? "";			
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}});	

	}

	
	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngAfterViewInit(): void {		
	}

	ngOnDestroy(): void {
		this.apiRequestsSub && this.apiRequestsSub.unsubscribe();
		this.postSubscribeSub && this.postSubscribeSub.unsubscribe();		
	}

	
	private loadData = () => {
		this.apiRequestsSub = combineLatest([
			this.sitesService.getSitesApi(), 
			this.listService.getRegionList(),
			this.listService.getCouncilList()]).subscribe(
			{
				next : (data) => {
					if(Array.isArray(data) && 3 === data?.length)
					{
						const beachSites = Array.isArray(data[0]) ? data[0] : [];
						this.allBeachSites = uniqWith(beachSites, (a : BeachSite, b : BeachSite) => {
							return a.Identifier === b.Identifier;
						});
						
						//this.allBeachSites$.next(beachSites);
						if(Array.isArray(data[1]))
						{
							const tmpRegions = uniqWith(data[1], (regionA : Region, regionB : Region) => {
								return regionA.RegionId === regionB.RegionId;
							});
							//const regions = tmpRegions
							//?.filter((a : Region) => {
							//	return isSubRegion(a);	
							//})
							const regions = tmpRegions?.map((region: Region) => {
								const regionBeachSites = getBeachSitesInArea(this.allBeachSites, tmpRegions, region);														
								return { ...region, Sites: regionBeachSites };
							})?.filter((region : Region) => {						
								return 0 < region.Sites?.length;
							})?.sort((a : any, b : any) => a.RegionName?.localeCompare(b.RegionName));	
							this.allRegions = regions;
						}
						else
						{
							this.allRegions = [];
						}
						//this.allRegions$.next(regions);

						if(Array.isArray(data[1]))
						{
							const tmpCouncils = uniqWith(data[2], (councilA : Council, councilB : Council) => {
								return councilA.CouncilId === councilB.CouncilId;							
							});
							
							const councils = tmpCouncils?.map((council: Council) => {							
								return { ...council, Sites: getBeachSitesInArea(this.allBeachSites, data[1], council, true) };
							}).filter((council : Council) => 0 < council.Sites?.length)?.sort((a : any, b : any) => a.CouncilName?.localeCompare(b.CouncilName));						
							this.allCouncils = councils;
						}
						else
						{
							this.allCouncils = [];
						}
						
						//this.allCouncils$.next(councils);
					}
			},
			error : (error : Error) => {
				console.log(error);
			},
			complete : () => {
				
			}
		});
	}
	

	get firstName() {
		return this.userSubscriptionsForm.get("firstName") as FormControl;
	}

	get lastName() {
		return this.userSubscriptionsForm.get("lastName");
	}

	get email() {
		return this.userSubscriptionsForm.get("email") as FormControl;
	}

	get updateFrequency() {
		return this.userSubscriptionsForm.get("updateFrequency");
	}

	get selectedMonths() {
		return this.userSubscriptionsForm.get("selectedMonths") as FormArray;
	}	

	get formIsValid() {
		//const isValid = this.userSubscriptionsForm.valid;
		const isValid =  "" !== this.firstName?.value?.toString()?.trim() && this.firstName?.valid && 
			("" === this.lastName?.value?.toString()?.trim() || ("" !== this.lastName?.value?.toString()?.trim() && this.lastName?.valid)) && 
			this.email?.valid && "" !== this.email?.value?.toString()?.trim() && 
			(
				(this.updateFrequency?.value === this.UPDATE_FREQUENCY[0]) ||
				(this.updateFrequency?.value === this.UPDATE_FREQUENCY[1] && this.selectedMonths?.valid)
			) 
			&& this.regionCouncilBeachSiteSelector?.valid;			

		return isValid;		
	}
	

	getFormControl (name : string)
	{
		return this.userSubscriptionsForm.get(name) as FormArray;
	}

	getControlByName(group : FormGroup, name : string) 
	{		
		return group.controls[name] as FormControl;		
	}

	getSiteControls(group : FormGroup, name : string) {
		return group.get(name) as FormArray
	}

	getCouncilRegionIndeterminateState = (control : AbstractControl, areaTypeName : LOOKUP_AREA_TYPES) => 
	{		
		const sites = (<FormArray>control.get(areaTypeName))?.controls;
		return sites.some((control : AbstractControl) => (<FormControl>control).value);		
	}

	onUpdateFreqSelectedMonthChange(event : any) {
		//console.log(event);
		// const idx = this.updateFreqSelectedMonths.indexOf(month);
		// if(-1 === idx)
		// {
		// 	this.updateFreqSelectedMonths.push(month);
		// }
		// else 
		// {
		// 	this.updateFreqSelectedMonths.splice(idx, 1);
		// }
	}

	clearAllSelectedMonths(event : any, reset : boolean = false)  {		
		this.selectedMonths?.controls?.forEach((ctrl) => {
			if(reset)
			{
				ctrl.reset();
			}
			else
			{
				ctrl.patchValue(false);
			}			
		});
	}

	selectAllMonths(event : any)  {
		event?.preventDefault();		
		this.selectedMonths?.controls?.forEach((ctrl) => {
			ctrl.patchValue(false);
		});
		this.updateFrequency?.patchValue(this.UPDATE_FREQUENCY[0]);		
	}	

	asFormControl( ctrl : AbstractControl<any>) : FormControl {
		return ctrl as FormControl;
	}
	

	submit () {
		if(this.formIsValid)
		{
			const { sites } = this.regionCouncilBeachSiteSelector?.getSelectedBeachSites();
			const payload = {
				regions : [],
				sites : sites,
				first_name : this.getFormControl("firstName")?.value,
				last_name : this.getFormControl("lastName")?.value,
				email : this.getFormControl("email")?.value,
				schedule : {
					notification_months : this.UPDATE_FREQUENCY[0] === this.getFormControl("updateFrequency").value ? [] :
						this.getFormControl("selectedMonths").controls.map((ctrl : any, index : number, arr : any[]) => {
							if(ctrl.value)
							{
								return this.updateMonths[index]
							}
							return "";
						}).filter(Boolean), 
					year_round : this.UPDATE_FREQUENCY[0] === this.getFormControl("updateFrequency").value
				}
			}
			this.submittingForm = true;
			
			let success = true, message = "";
			
			this.postSubscribeSub = this.userSubscribeService.subscribeUser(payload).subscribe({
				next : (response) => {
					success = true;
					message = response?.message ?? "You have successfully subscribed to Beachwatch updates.";									
				},
				error : (ex) => {
					success = false;
					message = "Oops! Something went wrong : " + ex?.message ?? "";					
				},
				complete : () => {
					const snackbarConfig : MatSnackBarConfig<any> = {
						duration : 1000,
						horizontalPosition : "right",
						verticalPosition : "top",
						panelClass : !success ? ["error-snackbar"] : ["success-snackbar"]
					}
					this.postSubscribeSub && this.postSubscribeSub.unsubscribe();			
					this.snackBar.open(message, "", <MatSnackBarConfig>snackbarConfig);
					this.onCancelClicked(null);
					this.submittingForm = false;
				}
			});			
		}
	}

	

	onCancelClicked(event : any) {
		this.suppressPopup = true;		
		this.firstName?.reset();
		this.lastName?.reset();
		this.email?.reset();
		this.updateFrequency?.reset();			
		this.regionCouncilBeachSiteSelector?.reset();
		if(this.preSelectedBeachSite)
		{
			// 	this.regionCouncilBeachSiteSelector?.setBeachSite(this.preSelectedBeachSite)
			// clear the pre-populated site identifier
			this.router.navigate(['.'], { relativeTo: this.activatedRoute });			
		}

		
		this.suppressPopup = false;	
	}	
}
